/* eslint-disable */
import Isotope from 'isotope-layout'
window.addEventListener('load', () => {

	const grid = document.querySelector('.grid')
	if (grid) {
		const iso = new Isotope( '.grid');
	}
})



// WEBPACK FOOTER //
// ./js/modules/content/layout/masonry.js